var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"xt-course-class-tag",class:_vm.classStr},[_c('span',{domProps:{"textContent":_vm._s(_vm.index)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }